import React from 'react';
import hsLogo from '../assets/hs-logo.svg';

export const Logo = ({ size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16'
  };

  return (
    <div className="flex items-center gap-3 shrink-0">
      <img
        src={hsLogo}
        alt="HS"
        className={`${sizeClasses[size]} object-contain shrink-0`}
        data-testid="logo-hs"
      />
      <span className="hidden sm:inline text-white font-light text-sm tracking-wide whitespace-nowrap" data-testid="logo-domain">
        hstrener.com
      </span>
    </div>
  );
};